<template>
 <div :class="windowClass">
    <v-row class="ma-1">
         <v-col cols="12" >
            <v-card class="pa-2">
              
                        <v-card-title>
                        <v-icon  left color="secondary">mdi-truck</v-icon> MANAGE TRUCKS  
                         <v-spacer></v-spacer>
                       <v-btn color="success" text @click="state='new', truckform=true" small><v-icon left>mdi-plus-box</v-icon> Add new</v-btn>
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="truckheaders"
                                :items="TRUCKS"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                      
                                        <td>
                                          <v-icon left x-small color="warning" @click="state='update', truck=item, truckform=true">mdi-pencil</v-icon>
                                          {{ item.name }}</td>
                                        <td>{{ item.description}}</td>
                                         <td>{{ item.plate_number}}</td>
                                          <td>{{ item.capacity}}  m&sup3;</td>
                                          <td>{{ $IsNum(item.weight)}} kg</td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
             </v-col>
              <v-col cols="12">

                    <v-card class="pa-2">
                        <v-card-title>
                        <v-icon  left color="secondary">mdi-account</v-icon> MANAGE DRIVERS  
                         <v-spacer></v-spacer>
                          <v-btn color="success" text @click="state='new', driverform=true" small><v-icon left>mdi-plus-box</v-icon> Add new</v-btn>
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="driverheaders"
                                :items="DRIVERS"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                      
                                        <td>
                                           <v-icon left x-small color="warning" @click="state='update', driver=item, driverform=true">mdi-pencil</v-icon>
                                          {{ item.fullname }} 
                                        </td>
                                        <td>{{ item.contact_number}}</td>
                                          <td>{{ item.license_number}}</td>
                                            <td>{{ item.status}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
             </v-col>
    </v-row>
    <va-truck-form :show="truckform" :item="truck" :state="state" @DialogEvent="formEvent" />
    <va-driver-form :show="driverform" :item="driver" :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        driverform: false,
        truckform: false,
        truck:{},
        driver: {},
        state: 'new',
        headers: [
            { text: 'Username', value:"username"},
            { text: 'Fullname', value:"fullname"},
            { text: 'Role', value:"role"},
            { text: 'Area', value: "assign_code" }
        ],
         truckheaders: [
            { text: 'Body Type', value:"name"},
            { text: 'Desc.', value:"description"},
             { text: 'Plate #.', value:"plate_number"},
             { text: 'Capacity', value:"capacity"},
             { text: 'Weight', value:"weight"},
        ],
         driverheaders: [
            { text: 'Name'},
            { text: 'Contact #.', value:"person"},
             { text: 'License #.', value:"license_number"},
             { text: 'Status', value:"status"}
        ],

    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.SET_MENUS()
           this.GET_TRUCKS()
           this.GET_DRIVERS()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      DRIVERS() {
        var arr = this.$store.state.drivers.reduce((res, item)=>{
            if(item.status=='active') {
              res.push(item)
            }
            return res
        },[])
        return arr
      },
      TRUCKS() {
        return this.$store.state.trucks
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent() {
        this.truckform = false
        this.driverform = false
         this.GET_TRUCKS()
           this.GET_DRIVERS()
      }
    }
  }
</script>